export default __webpack_public_path__ + "static/media/template26.f000a8bb.svg";